import React from "react";
import { Link } from "react-router-dom";

export default function Dates({ sale }) {
  return (
    <div>
      <div className="title">Important Dates</div>
      <div className="subtitle has-text-centered mb-4">
        <strong>Ski and Skate Sale</strong>
        <br />
        11/14 &bull; 9:00am–4:00pm
      </div>
      <ul className="has-text-left">
        <li>
          <strong>11/9</strong> at 11pm Consignment Registration Closes. There
          will be NO ON SITE CONSIGNMENT. ALL ITEMS MUST BE REGISTERED ONLINE BY
          11/9.
        </li>
        <li>
          <strong>11/11</strong> Tag Pickup @ Waitsfield Elementary School.
          Please find the envelope with your last name to pickup your printed
          tags for consignment items. Tags will be available at drop off Friday
          night if you cannot pick them up before.
        </li>
        <li>
          <strong>11/13</strong> Consignment Drop Off at Waitsfield Elementary
          from 4-7pm
        </li>
        <li>
          <strong>11/14</strong> Consignment Pickup 3:45-4:15. Check your Ski
          and Skate sale dashboard to see what has sold and what has not sold.
          Any unsold items not picked up by 4:15 will become property of the WES
          PTA.
        </li>
      </ul>
    </div>
  );
}
